import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'broken-paragraphs',
  templateUrl: './broken-paragraphs.component.html',
  styles: [
  ]
})
export class BrokenParagraphsComponent implements OnChanges {
  @Input('source') sourceText: string;
  @Input('className') className: string;

  split: string[];
  ngOnChanges(changes: SimpleChanges) {
    if (!changes['sourceText'].currentValue) {
      this.split = [];
      return;
    }
    this.split = changes['sourceText'].currentValue.split('\n');
  }
}
